// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--ysKWM","srOnly":"Footer-module--sr-only--3SsTN"};